import React, { useState, useEffect } from "react";
import { noImage } from "../../../assets";
import { useSelector, useDispatch } from "react-redux";
import { numberFormat } from "../../../helpers/numberFormat";
import { numberToDateString } from "../../../helpers/numberToDateString";
import {
  DetailBundlingProgramComp,
  DetailProgramComp,
  FormKatalogProgramMain,
} from "../..";
import Modal from "react-bootstrap/Modal";
import { MySwal } from "../../../lib/swal";
import "./style.css";

const KatalogProgramComp = (props) => {
  // console.log(props)
  const [detailProgram, setDetailProgram] = useState(false);
  const [detailBp, setDetailBp] = useState(false);
  const [formModal, setFormModal] = useState(false);
  const [filterPrograms, setFilterPrograms] = useState(props.programs);
  const [bundlingPrograms, setbundlingPrograms] = useState(
    props.bundlingPrograms
  );
  const [program, setProgram] = useState("");
  const [bp, setBp] = useState("");
  const [typeOfProgram, settypeOfProgram] = useState("all");

  const handleFilterTypeProgram = (value) => {
    dispatch({ type: "SET_SEARCH_PROGRAM", value: "" });
    if (value === "all") {
      setFilterPrograms(props.programs);
      settypeOfProgram(value);
    } else {
      settypeOfProgram(value);
      let newFilterPrograms = props.programs.filter((p) => p.type === value);
      setFilterPrograms(newFilterPrograms);
    }
  };

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const dispatch = useDispatch();
  const programSelected = useSelector((state) => state.programSelected);
  const bpSelected = useSelector((state) => state.bpSelected);
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );

  const handleProgramSelected = (value) => {
    dispatch({ type: "SET_PROGRAM_SELECTED", payload: value });
    dispatch({ type: "SET_INPUT_ALERT", payload: false });
  };

  const handleSelectedBp = (value) => {
    dispatch({ type: "SET_BP_SELECTED", payload: value });
    dispatch({ type: "SET_INPUT_ALERT", payload: false });
  };

  const handleTambahProgram = () => {
    if (programSelected.length === 0 && bpSelected === 0) {
      MySwal.fire({
        icon: "warning",
        title: "Oops, Kesalahan!",
        text: "Anda belum memilih program.",
        confirmButtonColor: "#6e7d88",
      });
    } else {
      setFormModal(true);
    }
  };

  const handleDetailProgram = (e, program) => {
    e.preventDefault();
    setDetailProgram(true);
    setProgram(program);
  };

  const handleDetailProgramBp = (e, bp) => {
    e.preventDefault();
    setDetailBp(true);
    setBp(bp);
  };

  useEffect(() => {
    if (dataInputRegistration.searchProgram.length > 0) {
      const result = filterPrograms.filter((item) => {
        let name = item.name;
        return name
          .toLowerCase()
          .match(dataInputRegistration.searchProgram.toLowerCase());
      });
      setFilterPrograms(result);

      const resultBp = bundlingPrograms.filter((item) => {
        let name = item.name;
        return name
          .toLowerCase()
          .match(dataInputRegistration.searchProgram.toLowerCase());
      });
      setbundlingPrograms(resultBp);
    } else {
      setFilterPrograms(props?.programs);
      setbundlingPrograms(props?.bundlingPrograms);
    }
    // eslint-disable-next-line
  }, [dataInputRegistration.searchProgram]);

  // console.log(dataInputRegistration.searchProgram)

  return (
    <>
      <div className="row">
        <div className="d-flex justify-content-start mb-2 mt-1">
          <span
            onClick={() => handleFilterTypeProgram("all")}
            className={
              typeOfProgram === "all"
                ? "badge badge-pill bg-blue"
                : "badge badge-pill bg-green"
            }
            style={{ fontSize: "12px" }}
            type="button"
          >
            All
          </span>
          &nbsp;
          <span
            onClick={() => handleFilterTypeProgram("Online")}
            className={
              typeOfProgram === "Online"
                ? "badge badge-pill bg-blue"
                : "badge badge-pill bg-green"
            }
            style={{ fontSize: "12px" }}
            type="button"
          >
            Online
          </span>
          &nbsp;
          <span
            onClick={() => handleFilterTypeProgram("Offline")}
            className={
              typeOfProgram === "Offline"
                ? "badge badge-pill bg-blue"
                : "badge badge-pill bg-green"
            }
            style={{ fontSize: "12px" }}
            type="button"
          >
            Offline
          </span>
        </div>
        {bundlingPrograms.map((bp, i) => (
          <div
            className="col-lg-3 col-md-6 col-12"
            style={{
              marginLeft: size.width < 500 ? "" : "15px",
              marginRight: "15px",
            }}
          >
            <div
              type="button"
              className="card"
              style={{
                color: bpSelected.some((item) => bp.id === item.id)
                  ? "#FFFFFF"
                  : "",
                backgroundColor: bpSelected.some((item) => bp.id === item.id)
                  ? "#0C86D9"
                  : "#F2F2F2",
                borderRadius: "10px",
                // height: size.width < 500 ? '70vh' : '60vh',
                marginTop: "3%",
                filter: detailProgram === true ? "blur(8px)" : "",
              }}
            >
              <div className="checkbox-container m-3">
                <input
                  type="checkbox"
                  className="checkbox"
                  onClick={(e) => handleSelectedBp(bp)}
                  checked={bpSelected.some((item) => bp.id === item.id)}
                />
                <h4 className="checkbox-label">Pilih Program</h4>
              </div>
              <img
                src={bp.coverLink || noImage}
                alt="prog1"
                width="100%"
                style={{
                  paddingLeft: "5%",
                  paddingRight: "5%",
                  paddingTop: "5%",
                }}
              />
              <div className="card-body">
                <div className="row">
                  <h4
                    style={{
                      color: bpSelected.some((item) => bp.id === item.id)
                        ? "#FFFFFF"
                        : "#0C86D9",
                      marginLeft: "13px",
                      fontSize: size.width < 500 ? "13px" : "15px",
                      fontWeight: "600",
                    }}
                  >
                    {bp.name}
                  </h4>
                </div>
                <ul style={{ marginTop: "2%", marginBottom: "5%" }}>
                  {bp?.BundlingProgramItems.map((bpi, j) => (
                    <li>*{bpi.Program.name} </li>
                  ))}
                </ul>
                {size.width < 500 ? (
                  <div className="d-flex justify-content-between">
                    <div className="col-lg-7">
                      <h5
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontSize: size.width < 500 ? "13px" : "15px",
                        }}
                      >
                        Rp. {numberFormat(bp.price)}
                      </h5>
                      <p
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontStyle: "italic",
                        }}
                      >
                        * belum termasuk PPN 12%
                      </p>
                    </div>
                    <div className="col-lg-5" style={{ textAlign: "right" }}>
                      <span
                        class="badge"
                        style={{ backgroundColor: "#26D07C", color: "#F2F2F2" }}
                      >
                        Available
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div className="col-lg-7">
                      <h5
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                        }}
                      >
                        Rp. {numberFormat(bp.price)}
                      </h5>
                      <p
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontStyle: "italic",
                          fontSize: "12px",
                        }}
                      >
                        * belum termasuk PPN 12%
                      </p>
                    </div>
                    <div className="col-lg-5" style={{ textAlign: "right" }}>
                      <span
                        class="badge"
                        style={{ backgroundColor: "#26D07C", color: "#F2F2F2" }}
                      >
                        Available
                      </span>
                    </div>
                  </div>
                )}

                {size.width < 500 ? (
                  ""
                ) : (
                  <div className="d-flex mt-3 mb-3">
                    <div className="col-6"></div>
                    <div
                      className="col-6 eli-color"
                      style={{ textAlign: "right" }}
                      onClick={(e) => handleDetailProgramBp(e, bp)}
                    >
                      <span style={{ fontSize: "14px" }}>
                        Detail Program&nbsp;
                        <i
                          style={{ fontSize: "14px", color: "black" }}
                          className="bi bi-arrow-right"
                        ></i>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

        {filterPrograms.map((program, i) =>
          program.Schedules.length > 0 ? (
            <div
              className="col-lg-3 col-md-6 col-12"
              style={{
                marginLeft: size.width < 500 ? "" : "15px",
                marginRight: "15px",
              }}
            >
              <div
                type="button"
                className="card"
                style={{
                  color: programSelected.some((item) => program.id === item.id)
                    ? "#FFFFFF"
                    : "",
                  backgroundColor: programSelected.some(
                    (item) => program.id === item.id
                  )
                    ? "#0C86D9"
                    : "#F2F2F2",
                  borderRadius: "10px",
                  // height: size.width < 500 ? '70vh' : '60vh',
                  marginTop: "3%",
                  filter: detailProgram === true ? "blur(8px)" : "",
                }}
              >
                <div className="checkbox-container m-3">
                  <input
                    type="checkbox"
                    className="checkbox"
                    onClick={(e) => handleProgramSelected(program)}
                    checked={programSelected.some(
                      (item) => program.id === item.id
                    )}
                  />
                  <h4 className="checkbox-label">Pilih Program</h4>
                </div>
                <img
                  src={program.coverLink || noImage}
                  alt="prog1"
                  width="100%"
                  style={{
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    paddingTop: "5%",
                  }}
                />
                <div className="card-body">
                  <div className="row">
                    <h4
                      style={{
                        color: programSelected.some(
                          (item) => program.id === item.id
                        )
                          ? "#FFFFFF"
                          : "#0C86D9",
                        marginLeft: "13px",
                        fontSize: size.width < 500 ? "13px" : "15px",
                        fontWeight: "600",
                      }}
                    >
                      {program.name}
                    </h4>
                  </div>
                  <ul style={{ marginTop: "2%", marginBottom: "5%" }}>
                    {program.Schedules.map((schedule, j) => (
                      <li>
                        {numberToDateString(schedule.startDate)} s/d{" "}
                        {numberToDateString(schedule.endDate)}
                      </li>
                    ))}
                  </ul>
                  {size.width < 500 ? (
                    <div className="d-flex justify-content-between">
                      <div className="col-lg-7">
                        <h5
                          style={{
                            color: programSelected.some(
                              (item) => program.id === item.id
                            )
                              ? "#FFFFFF"
                              : "",
                            fontSize: size.width < 500 ? "13px" : "15px",
                          }}
                        >
                          Rp. {numberFormat(program?.Pricebooks[0].price)}
                        </h5>
                        <p
                          style={{
                            color: programSelected.some(
                              (item) => program.id === item.id
                            )
                              ? "#FFFFFF"
                              : "",
                            fontStyle: "italic",
                          }}
                        >
                          * belum termasuk PPN 12%
                        </p>
                      </div>
                      <div className="col-lg-5" style={{ textAlign: "right" }}>
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#26D07C",
                            color: "#F2F2F2",
                          }}
                        >
                          Available
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex">
                      <div className="col-lg-7">
                        <h5
                          style={{
                            color: programSelected.some(
                              (item) => program.id === item.id
                            )
                              ? "#FFFFFF"
                              : "",
                          }}
                        >
                          Rp. {numberFormat(program?.Pricebooks[0].price)}
                        </h5>
                        <p
                          style={{
                            color: programSelected.some(
                              (item) => program.id === item.id
                            )
                              ? "#FFFFFF"
                              : "",
                            fontStyle: "italic",
                            fontSize: "12px",
                          }}
                        >
                          * belum termasuk PPN 12%
                        </p>
                      </div>
                      <div className="col-lg-5" style={{ textAlign: "right" }}>
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#26D07C",
                            color: "#F2F2F2",
                          }}
                        >
                          Available
                        </span>
                      </div>
                    </div>
                  )}

                  {size.width < 500 ? (
                    ""
                  ) : (
                    <div className="d-flex mt-3 mb-3">
                      <div className="col-6"></div>
                      <div
                        className="col-6 eli-color"
                        style={{ textAlign: "right" }}
                        onClick={(e) => handleDetailProgram(e, program)}
                      >
                        <span style={{ fontSize: "14px" }}>
                          Detail Program&nbsp;
                          <i
                            style={{ fontSize: "14px", color: "black" }}
                            className="bi bi-arrow-right"
                          ></i>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )
        )}
      </div>

      {
        // jika bundling program
        props.programCategory === "3" ? (
          <>
            <div
              className="d-flex justify-content-end mt-3 mb-3"
              style={{ filter: detailProgram === true ? "blur(8px)" : "" }}
            >
              {size.width < 500 ? (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              ) : (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              className="d-flex justify-content-end mt-3 mb-3"
              style={{ filter: detailProgram === true ? "blur(8px)" : "" }}
            >
              {size.width < 500 ? (
                <button
                  disabled={filterPrograms.length > 0 ? false : true}
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              ) : (
                <button
                  disabled={
                    filterPrograms.length > 0
                      ? false
                      : true && props.programCategory !== 3
                  }
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              )}
            </div>
          </>
        )
      }

      <Modal
        show={detailProgram}
        size="lg"
        onHide={() => setDetailProgram(false)}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <DetailProgramComp program={program} />
        </Modal.Body>
      </Modal>

      <Modal show={detailBp} size="lg" onHide={() => setDetailBp(false)}>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <DetailBundlingProgramComp bundlingProgram={bp} />
        </Modal.Body>
      </Modal>

      <Modal
        show={formModal}
        fullscreen={true}
        onHide={() => setFormModal(false)}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <FormKatalogProgramMain close={() => setFormModal(false)} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default KatalogProgramComp;
